module.exports = __webpack_public_path__ + "static/media/mail.3c6ad736.svg";